
import { Card, Tabs } from 'antd';
import ChangePassword from 'components/MyProfile/ChangePassword';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import React from 'react'
import PersonalInformation from 'components/MyProfile/PersonalInformation';

export default function MyProfile() {
    useTopbarTitleHooks("My Profile");
    return (
        <div className='container-my-profile'>
            <Card>
                <Tabs
                    defaultActiveKey="1"
                    type="card"
                    size="small"
                    items={
                        [
                            {
                                key: 1,
                                forceRender: true,
                                label: "Change Password",
                                children: <ChangePassword />
                            },
                            // {
                            //     key: 2,
                            //     forceRender: true,
                            //     label: "Personal Information",
                            //     children: <PersonalInformation />
                            // },
                            
                        ]
                    }
                />
            </Card>
        </div>
    )
}
